<template>
    <nav class="navbar" :class="{ 'header-bg': !isHome || scrolledDown }" @mouseenter="handelNavHover"
        @mouseleave="handelNavLeave">
        <!-- 分辨率在990之下的时候展示页按钮 -->
        <div class="router-btn router-show">
            <div class="nav-btn-box" @click="drawer = true">
                <img :src="isHome
                    ? (navHover || scrolledDown
                        ? require('@/assets/assetsNew/header/router.png')
                        : require('@/assets/assetsNew/header/router2.png'))
                    : require('@/assets/assetsNew/header/router.png')" />
            </div>

        </div>
        <el-drawer :visible.sync="drawer" :with-header="false" :direction="'ltr'" :size="'90%'" :modal="false">
            <div class="drawer-content">
                <div class="drawer-content-top">
                    <i class="el-icon-close" @click="drawer = false" :size="40"></i>
                </div>
                <div class="drawer-content-bottom">
                    <ul class="mobile-nav mobile-nav--main">
                        <li class="mobile-nav__link" v-for="(item, index) in navList" :key="index"
                            @click="navToLink(item, index)">
                            <router-link :to="item.path" class="nav-item-link">
                                <div class="path-text">
                                    {{ item.title }}
                                    <!-- <span :class="seachActive ? '' : navActiveKey === index ? 'navClickSpan' : ''"></span> -->
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </el-drawer>
        <!-- logo -->
        <div class="logo">
            <a href="/">
                <img src="@/assets/assetsNew/header/logo2.png" alt="" @click="logoLinkHome">
            </a>
        </div>
        <!-- 导航栏外加按钮 -->
        <div class="nav-container">
            <!-- 文字链接 -->
            <div class="navbar-nav-show">
                <ul class="navbar-nav">
                    <li class="nav-item" v-for="(item, index) in navList" :key="index" @click="navToLink(item, index)">
                        <router-link :to="item.path" class="nav-item-link">
                            <div class="nav-item-link-text" :class="{ 'text-color': !isHome || scrolledDown,'text-color-active':isNavClickIndex === index }">
                                {{ item.title }}
                                <!-- <span :class="seachActive ? '' : navActiveKey === index ? 'navClickSpan' : ''"></span> -->
                            </div>
                        </router-link>

                    </li>
                </ul>
            </div>
            <!-- 三个按钮 -->
            <div class="nav-btn">
                <div class="nav-btn-box" @click="seachClick">
                    <img :src="isHome
                        ? (navHover || scrolledDown
                            ? require('@/assets/assetsNew/header/search1.png')
                            : require('@/assets/assetsNew/header/search2.png'))
                        : require('@/assets/assetsNew/header/search1.png')" />
                </div>
                <el-dropdown trigger="click" @command="handleDropdownCommand">
                    <div class="nav-btn-box">
                        <!-- <img
                            :src="navHover || scrolledDown ? require('@/assets/assetsNew/header/locals2.png') : require('@/assets/assetsNew/header/locals1.png')"></img> -->
                        <img :src="isHome
                            ? (navHover || scrolledDown
                                ? require('@/assets/assetsNew/header/locals2.png')
                                : require('@/assets/assetsNew/header/locals1.png'))
                            : require('@/assets/assetsNew/header/locals2.png')" />
                    </div>
                    <el-dropdown-menu slot="dropdown" class="el-dropdown-menu">
                        <el-dropdown-item v-for="(item, index) in localesOptions.slice(0,1).concat(localesOptions.slice(-1))" :key="index" :command="item.value"
                            :class="{ 'is-active': selectedValue === item.value }">{{ item.label
                            }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

        </div>

    </nav>

</template>

<script>
import { bus } from '@/utils/bus'
import { getNavListing } from '@/api/komo';

export default {
    async created() {
        this.initData()
        this.initScrollAnimation()
        this.handleResize()
        this.checkMobile()
        this.selectedValue = this.$i18n.locale
        this.localesValue = this.$i18n.locale
    },
    name: 'headerCont',
    props: {
        scrolledDown: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSearch: false,
            drawer: false,
            isHome: true,
            navHover: false,
            // navList: this.$t('nav'),
            navList: [],
            navActiveKey: 0,
            seachActive: false,
            localesOptions: this.$t('navLocalesNew'),
            localesValue: 0,
            isMobileMenuOpen: false,
            selectedValue: 0,
            isMobileFlag: false,
            isNavClickIndex:null
        }
    },
    // props: {
    //     isMobile: {
    //         type: Boolean,
    //         default: false
    //     }
    // },
    mounted() {
        console.log('this.$pagePath', this.$pagePath)
        // console.log('this.isMobile', this.isMobile)
        // this.isMobileFlag = this.isMobile;
        // // 在移动端点击导航项后关闭菜单
        // if (window.innerWidth < 992) {
        //     this.isMobileMenuOpen = false;
        // } else {
        //     this.isMobileMenuOpen = true;
        // }
        // 初始化激活项
        // this.updateActiveByRoute();
        // this.$i18n.locale = 'zh-Hans';
        this.$i18n.locale = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en';
        localStorage.setItem('locale', localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en')

        bus.$emit('locale-change', this.$i18n.locale)

        // 初始化pageId
        localStorage.setItem('pageId', localStorage.getItem('pageId') ? localStorage.getItem('pageId') : 1);
        // localStorage.setItem('locale', 'zh-Hans');
        // 更新导航列表
        // this.navList = this.$t('nav');
    },
    watch: {
        // 路由变化时，更新选中导航
        $route() {
            this.updateActiveByRoute();
        },
        isMobile(val) {
            console.log('isMobile', val)
            this.isMobileFlag = val;
        },
        scrolledDown(val) {
            console.log('是否移动进度条', val)
        },
    },
    created() {
        // 获取导航列表
        this.getNavListing();
        console.log('selectedValue', localStorage.getItem('selectedValue'));
        this.selectedValue = Number(localStorage.getItem('selectedValue') ? localStorage.getItem('selectedValue') : 0);//初始值为英语 : 1
    },
    methods: {
        handelNavHover() {
            this.navHover = true;
            console.log('navHover', this.navHover)
        },
        handelNavLeave() {
            this.navHover = false;
        },
        // 获取路由数据
        async getNavListing() {
            const res = await getNavListing();
            if (res.error === 0 && res.data) {
                this.navList = res.data?.list;
                // 导航数据加载完成后，更新激活状态
                this.$nextTick(() => {
                    this.updateActiveByRoute();
                });
            }
        },
        // 导航项点击
        navToLink(item, index) {
            console.log(item, index)
            this.isNavClickIndex = index;
            this.navActiveKey = index;
            this.seachActive = false;
            this.$emit('navToLink', item.title);
            localStorage.setItem('pageId', item.id);

            // 手机端点击路由关闭路由菜单
            this.isMobileMenuOpen = false;
            this.drawer = false;
        },
        handleDropdownCommand(command) {
            this.selectedValue = command;
            console.log('selectedValue', command)
            localStorage.setItem('selectedValue', command);
            // 根据command的值进行相应的操作
            // 例如，根据command的值切换语言
            switch (command) {
                case 0:
                    this.$i18n.locale = 'en';
                    localStorage.setItem('locale', 'en');
                    break;
                case 1:
                    this.$i18n.locale = 'zh-Hans';
                    localStorage.setItem('locale', 'zh-Hans');
                    break;
                case 2:
                    this.$i18n.locale = 'Indonesia';
                    localStorage.setItem('locale', 'Indonesia');
                    break;
                case 3:
                    this.$i18n.locale = 'Malaysia';
                    localStorage.setItem('locale', 'Malaysia');
                    break;
                case 4:
                    this.$i18n.locale = 'Thailand';
                    localStorage.setItem('locale', 'Thailand');
                    break;
                case 5:
                    this.$i18n.locale = 'Brazil';
                    localStorage.setItem('locale', 'Brazil');
                    break;
                default:
                    this.$i18n.locale = 'en';
                    localStorage.setItem('locale', 'en');
                    break;
            }
            // 触发事件通知其他模块
            bus.$emit('locale-change', this.$i18n.locale)
            window.location.reload(true);  //语言切换之后刷新页面
            // 更新导航列表
            // this.navList = this.$t('nav');
        },
        logoLinkHome() {
            this.$router.push('/');
            this.navActiveKey = 0;
            this.seachActive = false;
            // 在移动端点击logo后关闭菜单
            if (window.innerWidth < 992) {
                this.isMobileMenuOpen = false;
            }
        },
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },
        updateActiveByRoute() {
            // 确保导航数据已加载
            if (!this.navList || this.navList.length === 0) {
                return;
            }

            const path = this.$route && this.$route.path ? this.$route.path : '/';
            let idx = -1;

            // 特殊处理根路径
            if (path === '/') {
                idx = this.navList.findIndex(n => n.path === '/' || n.toLink === '/');
            } else {
                // 对于非根路径，查找匹配的导航项
                idx = this.navList.findIndex(n => {
                    // 检查 path 字段（当前使用的字段）
                    if (n.path && n.path !== '/' && path.startsWith(n.path)) {
                        return true;
                    }
                    // 检查 toLink 字段（之前代码中使用的字段）
                    if (n.toLink && n.toLink !== '/' && path.startsWith(n.toLink)) {
                        return true;
                    }
                    return false;
                });
            }

            this.navActiveKey = idx >= 0 ? idx : 0;
            console.log('更新导航激活项:', this.navActiveKey, '当前路径:', path);
            localStorage.setItem('pageId', this.navList[this.navActiveKey].id);

            // 处理当页面不是首页的时候导航栏的样式
            this.isHome = path === '/';
            console.log('当前是否在首页', this.isHome);
        },
        seachClick() {
            this.$emit('navToLink', this.$t('seach.button'));
            this.seachActive = true;
            if (this.$route.path !== '/seach') {
                this.$router.push({ path: '/seach' });
            }
            //   新版搜索
            // this.$emit('openSearch', true);

        }
    }
}
</script>

<style scoped>
.navbar {
    padding: 0 5%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: var(--nav-max-height);
    position: relative;
    transition: background-color 800ms ease, border-color 800ms ease;
}

.navbar:hover {
    background: #ffffff;
}

.navbar:hover .nav-item-link-text {
    color: #422b20;
}

.header-bg {
    background: #ffffff;
    border-bottom: 1px solid #e6e5e7;
}


/* 手机版的导航样式 */
.drawer-content {}

.drawer-content-top {
    text-align: right;
    padding: 10px 15px;
}

.drawer-content-bottom ul {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.mobile-nav {
    margin: 0;
    padding: 0 15px;
    font-size: 18px;
}

.mobile-nav.mobile-nav--main {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
}

.mobile-nav__link {
    list-style: none;
    padding: 10px 0;

}

.path-text {
    color: #242424;
    font-family: var(--navigation-font-stack);
    font-weight: var(--navigation-font-weight);
    font-style: var(--navigation-font-style);
    text-transform: var(--header-font-case);
    letter-spacing: var(--navigation-font-letter-spacing);
}

.logo {
    width: 130px;
    max-width: 130px;
    /* height: 30px; */
    /* position: relative; */
}

.logo img {
    width: 100%;
    height: 100%;
    cursor: pointer;
    object-fit: contain;
    /* position: absolute;
    top: 0; */
}


.nav-container {
    display: flex;
    align-items: center;
}

/* 导航盒子 */

.navbar-nav {
    display: flex;
    flex-direction: row;
    gap: 30px;
    color: #422b20;
    height: 50px;
    align-items: center;
}


/* 导航文字 */
.nav-item-link {
    text-decoration: none;
}

.text-color {
    color: #422B20 !important;
}

.nav-item-link-text {
    color: #ffffff;
    font-size: 14px;
    font-family: Inter, sans-serif;
    display: inline-block;
    /* 让宽度跟随文字，而不是整行 */
    padding-bottom: 2px;
    position: relative;
    cursor: pointer;
}

.nav-item-link-text::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 1px;
    /* 下划线粗细 */
    width: 0;
    background: #422b20;
    /* 想要的颜色 */
    transition: width .3s ease;
    /* 动画时间可改 */
}

.nav-item-link-text:hover::after {
    width: 100%;
}
.text-color-active::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 1px;
    /* 下划线粗细 */
    width: 100%;
    background: #422b20;
    /* 想要的颜色 */
    transition: width .3s ease;
    /* 动画时间可改 */
}

/* 导航按钮 */
.nav-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-left: 20px;
}

.router-btn {
    display: flex;
    align-items: center;
}

.router-show {
    display: none;
}

.nav-btn-box {
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.nav-btn-box img {
    width: 20px;
    height: 20px;
}



.locales .navbar-toggler {
    margin-left: 20px;
    border: none;
    outline: none;
    width: 2.5vw;
    height: 2.5vw;
    position: relative;

}


.el-dropdown-menu {
    width: 9%;
}

.el-dropdown-menu__item.is-active {
    color: #409EFF;
    background-color: #ecf5ff;
}

/* 分辨率为1115下 */
@media screen and (max-width: 1115px) {
    .navbar {
        height: var(--nav-1115-height);
    }

    .logo {
        width: 130px;
        /* height: 27px; */
    }

    .nav-container {
        flex-direction: column;
    }

    .nav-btn {
        justify-content: flex-end;
        width: 100%;
    }

    .el-dropdown-menu {
        width: 20%;
    }
}

/* 分辨率为990下 */
@media screen and (max-width: 990px) {
    .navbar {
        height: var(--nav-990-height);
        position: relative;
    }

    .navbar-nav-show {
        display: none;
    }

    .router-show {
        display: block;
    }

    .logo {
        width: 75px;
        /* height: 22px; */
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
}

@media screen and (max-width: 768px) {
    .el-dropdown-menu {
        width: 30%;
    }
}
</style>